import React from "react";
import { Row, Col, Tag, Space } from "antd";
import stoolImg from "./StoolSampleImg";
import hard1 from "./images/stool/hard-1.png";
import hard2 from "./images/stool/hard-2.png";
import hard3 from "./images/stool/hard-3.png";
import formed from "./images/stool/formed.png";
import loose1 from "./images/stool/loose-1.png";
import loose2 from "./images/stool/loose-2.png";
import watery from "./images/stool/watery.png";

const imgBase64 = "data:image/jpg;base64," + stoolImg;

function StoolAi(props) {
    return (
        <>
            <Row gutter={24}>
                <Col className="gutter-row" span={12} order={2} md={5}>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "hard" &&
                            props.aiInferences?.score === 1
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultType("hard", 1)}
                    >
                        <Space>
                            Hard 1
                            <img src={hard1} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "hard" &&
                            props.aiInferences?.score === 2
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultType("hard", 2)}
                    >
                        <Space>
                            Hard 2
                            <img src={hard2} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "hard" &&
                            props.aiInferences?.score === 3
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultType("hard", 3)}
                    >
                        <Space>
                            Hard 3
                            <img src={hard3} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "formed"
                                ? "active"
                                : ""
                        } `}
                        onClick={() =>
                            props.handleChangeResultType("formed", 4)
                        }
                    >
                        <Space>
                            Formed
                            <img src={formed} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "loose" &&
                            props.aiInferences?.score === 5
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultType("loose", 5)}
                    >
                        <Space>
                            Loose 1
                            <img src={loose1} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "loose" &&
                            props.aiInferences?.score === 6
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultType("loose", 6)}
                    >
                        <Space>
                            Loose 2
                            <img src={loose2} alt="" />
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.consistency === "watery"
                                ? "active"
                                : ""
                        } `}
                        onClick={() =>
                            props.handleChangeResultType("watery", 7)
                        }
                    >
                        <Space>
                            Watery
                            <img src={watery} alt="" />
                        </Space>
                    </Tag>
                </Col>
                <Col
                    className="gutter-row"
                    span={24}
                    order={1}
                    md={{ span: 14, order: 2 }}
                >
                    <div
                        style={{
                            backgroundImage:
                                "url(" +
                                (props.aiInferences.photoBase64
                                    ? props.aiInferences.photoBase64
                                    : imgBase64) +
                                ")",
                        }}
                        className="stool-sample-img"
                    ></div>
                </Col>
                <Col className="gutter-row" span={12} order={3} md={5}>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Yellow"
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Yellow")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#E4D74D" }}
                            ></div>
                            Yellow
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Orange"
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Orange")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#E47646" }}
                            ></div>
                            Orange
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Green"
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Green")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#306F27" }}
                            ></div>
                            Green
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Brown"
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Brown")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#795F1F" }}
                            ></div>
                            Brown
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Black"
                                ? "active"
                                : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Black")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#1C1C1D" }}
                            ></div>
                            Black
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Pale/Clay"
                                ? "active"
                                : ""
                        } `}
                        onClick={() =>
                            props.handleChangeResultColor("Pale/Clay")
                        }
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#A4A4A4" }}
                            ></div>
                            Pale/Clay
                        </Space>
                    </Tag>
                    <Tag
                        className={`stool-tag ${
                            props.aiInferences?.color === "Red" ? "active" : ""
                        } `}
                        onClick={() => props.handleChangeResultColor("Red")}
                    >
                        <Space align="center">
                            <div
                                className="stool-color"
                                style={{ backgroundColor: "#921C16" }}
                            ></div>
                            Red
                        </Space>
                    </Tag>
                </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 12 }}>
                <Col span={0} md={5}></Col>
                <Col span={24} md={14}>
                    <p className="app-text-16 app-text-14 app-text-center">
                        Adjust the AI suggested results if you do not agree with
                        them.
                    </p>
                    <p className="app-text-16 app-text-14 app-text-center">
                        Then click Show Result.
                    </p>
                </Col>
                <Col span={0} md={5}></Col>
            </Row>
        </>
    );
}

export default StoolAi;
